<script>
    import { useNavigate, useLocation } from 'svelte-navigator';
    import { CALL_STATE_CONSTANTS } from '../services/utils';
    import sessionState from '../store/session';
    import authState from '../store/auth';
    import callState from '../store/call';

    const navigate = useNavigate();
    const location = useLocation();

    $: if (!$authState.isLoggedIn) {
        navigate('/login', {
            state: { from: $location.pathname },
            replace: true,
        });
    }
    
    $: if ($authState.isLoggedIn && (!$sessionState.profile || Object.values($sessionState.profile).length === 0)) {
        navigate('/choose-business');
    }

    $: if ($authState.isLoggedIn && (!$sessionState.receiver || Object.keys($sessionState.receiver).length === 0)) {
        navigate('/choose-number');
    }
    
    $: {
        if (
           ([
                // CALL_STATE_CONSTANTS.INCALL, 
                CALL_STATE_CONSTANTS.OUTGOING, 
                CALL_STATE_CONSTANTS.RINGING
            ].includes($callState.state)
            && !$callState.minimize) || $callState.callActive
        ) {
            navigate("/call")
        }
    }
</script>

{#if $authState.isLoggedIn}
    <slot />
{/if}
